import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6850da14"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "탑승", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "boarding-btn",
    type: "button",
    onClick: _withModifiers($setup.emitOnClick, ["stop"])
  }, [
    _hoisted_1,
    _createVNode($setup["InlineSvg"], {
      class: "bell-icon",
      src: require('@/assets/icons/bell-on-outlined.svg'),
      "aria-hidden": "true"
    }, null, 8 /* PROPS */, ["src"])
  ]))
}